// ======================================================================
// FILE: src/modules/wms/dashboard/components/SLAComplianceCard.jsx
// MODULE: Work Management System (WMS)
// PURPOSE:
//   SLA Compliance Overview
// ======================================================================

import React from "react";

export default function SLAComplianceCard({
  data = {},
}) {
  const within = Number(data.within || 0);
  const warning = Number(data.warning || 0);
  const breached = Number(data.breached || 0);

  const total = within + warning + breached;

  const compliance = Number(data.compliance || 0);

  const withinPercentage =
    total > 0 ? (within / total) * 100 : 0;

  const warningPercentage =
    total > 0 ? (warning / total) * 100 : 0;

  const breachedPercentage =
    total > 0 ? (breached / total) * 100 : 0;

  return (
    <div className="card shadow-sm mb-4">
      <div className="card-header bg-white d-flex justify-content-between align-items-center">
        <h5 className="mb-0">
          SLA Compliance
        </h5>

        <span className="badge bg-success">
          {compliance}% Healthy
        </span>
      </div>

      <div className="card-body">
        <div className="row text-center mb-4">
          <div className="col">
            <h3 className="text-success">
              {within}
            </h3>
            <small className="text-muted">
              Within SLA
            </small>
          </div>

          <div className="col">
            <h3 className="text-warning">
              {warning}
            </h3>
            <small className="text-muted">
              Near Breach
            </small>
          </div>

          <div className="col">
            <h3 className="text-danger">
              {breached}
            </h3>
            <small className="text-muted">
              Breached
            </small>
          </div>
        </div>

        <div
          className="progress"
          style={{ height: 18 }}
        >
          <div
            className="progress-bar bg-success"
            style={{ width: `${withinPercentage}%` }}
          />

          <div
            className="progress-bar bg-warning"
            style={{ width: `${warningPercentage}%` }}
          />

          <div
            className="progress-bar bg-danger"
            style={{ width: `${breachedPercentage}%` }}
          />
        </div>

        <div className="d-flex justify-content-between mt-2">
          <small className="text-success">
            Within SLA
          </small>

          <small className="text-warning">
            Warning
          </small>

          <small className="text-danger">
            Breached
          </small>
        </div>
      </div>
    </div>
  );
}
